import { render } from "./AgregarSuperAdministrador.vue?vue&type=template&id=5da3f3aa&scoped=true"
import script from "./AgregarSuperAdministrador.vue?vue&type=script&lang=js"
export * from "./AgregarSuperAdministrador.vue?vue&type=script&lang=js"

import "./AgregarSuperAdministrador.vue?vue&type=style&index=0&id=5da3f3aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5da3f3aa"]])

export default __exports__